import { makeStyles } from '@material-ui/core';

const useCondensedStyles = makeStyles((theme) => ({
  '@global': {
    body: {
      backgroundColor: 'transparent',
    },
  },
  condensedSDKView: {
    width: '100%',
    height: '100%',
    [theme.breakpoints.up('md')]: {
      maxWidth: '800px',
      maxHeight: '600px',
      height: ' calc(100% + 16px)',
      position: 'absolute',
      transform: 'translate(-50%,-50%)',
      top: '50%',
      left: '50%',
      '& #app-layout': {
        maxHeight: 'calc(100% - 64px)',
        height: '100%',
        margin: 0,
        borderRadius: 0,
      },
    },
    '&.whiteLabel': {
      '& #app-layout': {
        maxHeight: 'calc(100%)',
      },
    },
    '&.auth': {
      [theme.breakpoints.down('sm')]: {
        height: 'auto',
        position: 'absolute',
        bottom: 0,
        right: 0,
        left: 'auto',
        transform: 'translate(0)',
        minHeight: '200px',
        '& #app-layout': {
          padding: 16,
          minHeight: 'calc(200px - 16px)',
        },
      },
    },
  },
  mirrorBackdrop: {
    width: '100%',
    height: '100%',
  },
}));

export default useCondensedStyles;
